/*
*######################################
* eWebEditor for Vue2 V1.6 - Advanced online web based WYSIWYG HTML editor.
* Copyright (c) 2003-2023 eWebSoft.com
*
* For further information go to http://www.ewebeditor.net/
* This copyright notice MUST stay intact for use.
*######################################
*/

import EwebEditorComponent from './EwebEditor.js';

const EwebEditor = {

	/**
	 * Installs the plugin, registering the `<EwebEditor>` component.
	 *
	 * @param {Vue} Vue The Vue object.
	 */
	install(Vue) {
		Vue.component('EwebEditor', EwebEditorComponent);
	},
	component: EwebEditorComponent
};

export default EwebEditor;